import React, { useState, useMemo, useEffect } from 'react';
import { Row, Col, Form, Button, Card, Spinner, Pagination } from 'react-bootstrap';
import Select from 'react-select';
import { useLocation } from 'react-router-dom';
import Header from '~/Components/Header/Header';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import { FaSearch, FaPlus, FaArrowRight, FaEdit, FaTrash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { listarDepartamentos, buscarAssuntosFaq, buscarCriadoresFaq, buscarConteudosFaq, excluirConteudoFaq, buscarUsuarioLogado } from '~/Services/Service';
import ModalInclusao from '~/Components/FAQ/ModalInclusao';
import DetalhesFAQ from '~/Components/FAQ/DetalhesFAQ';
import ModalConfirmacao from '~/Components/ModalConfirmacao';
import AuthStorage from '~/Utils/AuthStorage';
import { caracteristicas } from '~/constant';


const FAQ = () => {
  const location = useLocation();
  var podeGerenciar = AuthStorage.temCaracteristicas([caracteristicas.GerenciaAssuntoFaq]);
  const [departamentoUsuario, setDepartamentoUsuario] = useState(null);
  const [departamentoOptions, setDepartamentoOptions] = useState([]);
  const [assuntoOptions, setAssuntoOptions] = useState([]);
  const [usuarioOptions, setUsuarioOptions] = useState([]);
  const [departamento, setDepartamento] = useState(null);
  const [assunto, setAssunto] = useState(null);
  const [dataCriacaoInicio, setDataCriacaoInicio] = useState('');
  const [dataCriacaoFim, setDataCriacaoFim] = useState('');
  const [usuario, setUsuario] = useState(null);
  const [pesquisa, setPesquisa] = useState('');
  const [loading, setLoading] = useState(false);
  const [resultados, setResultados] = useState([]);
  const [showModalInclusao, setShowModalInclusao] = useState(false);
  const [itemSelecionado, setItemSelecionado] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [showConfirmExcluir, setShowConfirmExcluir] = useState(false);
  const [itemExcluir, setItemExcluir] = useState(null);
  const [conteudoEdicao, setConteudoEdicao] = useState(null);


  useEffect(function() {
    listarDepartamentos().then(function(res) {
      var deptos = res || [];
      setDepartamentoOptions(
        deptos.map(function(d) {
          return { value: d.codigo, label: d.descricao };
        })
      );
    }).catch(function() { /* ignore */ });

    buscarCriadoresFaq().then(function(res) {
      var users = res || [];
      setUsuarioOptions(
        users.map(function(u) {
          return { value: u.codigo, label: u.nome };
        })
      );
    }).catch(function() { /* ignore */ });

    buscarUsuarioLogado().then(function(res) {
      if (res && res.codigo_departamento) {
        setDepartamentoUsuario(res.codigo_departamento);
      }
    }).catch(function() { /* ignore */ });
  }, []);

  useEffect(function() {
    if (location.state && location.state.itemSelecionado) {
      setItemSelecionado(location.state.itemSelecionado);
    }
  }, [location.state]);

  useEffect(function() {
    if (!departamento) {
      setAssuntoOptions([]);
      setAssunto(null);
      return;
    }
    buscarAssuntosFaq(departamento.value).then(function(res) {
      var assuntos = res || [];
      setAssuntoOptions(
        assuntos.map(function(a) {
          return { value: a.codigo, label: a.nome };
        })
      );
    }).catch(function() {
      setAssuntoOptions([]);
    });
    setAssunto(null);
  }, [departamento]);
  const [recordsPerPage] = useState(5);

  const totalPages = Math.ceil(resultados.length / recordsPerPage);

  const registrosPaginados = useMemo(() => {
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    return resultados.slice(indexOfFirstRecord, indexOfLastRecord);
  }, [resultados, currentPage, recordsPerPage]);

  const trocarPagina = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleBuscar = () => {
    setLoading(true);
    setCurrentPage(1);
    var params = {};
    if (departamento) params.codigoDepartamento = departamento.value;
    if (assunto) params.codigoAssunto = assunto.value;
    if (dataCriacaoInicio) params.dataInicial = dataCriacaoInicio;
    if (dataCriacaoFim) params.dataFinal = dataCriacaoFim;
    if (pesquisa.trim()) params.titulo = pesquisa.trim();
    if (usuario) params.CodigoUsuarioCriador = usuario.value;
    buscarConteudosFaq(params)
      .then(function(res) {
        var dados = res || [];
        setResultados(dados);
      })
      .catch(function() {
        toast.error('Erro ao buscar Tópicos. Tente novamente.');
        setResultados([]);
      })
      .finally(function() {
        setLoading(false);
      });
  };

  const handleLimpar = () => {
    setDepartamento(null);
    setAssunto(null);
    setDataCriacaoInicio('');
    setDataCriacaoFim('');
    setUsuario(null);
    setPesquisa('');
  };

  const handleExcluir = (item) => {
    setItemExcluir(item);
    setShowConfirmExcluir(true);
  };

  const confirmarExclusao = (confirmado) => {
    setShowConfirmExcluir(false);
    if (!confirmado) return;
    excluirConteudoFaq(itemExcluir.codigo)
      .then(function() {
        toast.success('Tópico excluído com sucesso!');
        handleBuscar();
      })
      .catch(function(err) {
        var msg = err && err.response && err.response.data && err.response.data.mensagem
          ? err.response.data.mensagem
          : 'Erro ao excluir Tópico. Tente novamente.';
        toast.error(msg);
      });
  };

  return (
    <>
      <Header title="FAQ" />
      <div className="container-fluid mt-3 px-2 px-sm-3" style={{ overflowX: 'hidden', maxWidth: '100%' }}>
        <Card className="shadow-sm mb-3">
          <Card.Body className="px-2 px-sm-3">
            <Row className="align-items-center mb-3">
              <Col xs={12} sm={6} md={3}>
                <Form.Group>
                  <Form.Label>Departamento</Form.Label>
                  <Select
                    placeholder="Selecione"
                    options={departamentoOptions}
                    value={departamento}
                    onChange={setDepartamento}
                    styles={customStyles}
                    components={{ DropdownIndicator }}
                    noOptionsMessage={() => 'Nenhuma opção'}
                    menuPortalTarget={document.body}
                    isClearable
                  />
                </Form.Group>
              </Col>
              <Col xs={12} sm={6} md={3}>
                <Form.Group>
                  <Form.Label>Assunto</Form.Label>
                  <Select
                    placeholder="Selecione"
                    options={assuntoOptions}
                    value={assunto}
                    onChange={setAssunto}
                    styles={customStyles}
                    components={{ DropdownIndicator }}
                    noOptionsMessage={() => 'Nenhuma opção'}
                    menuPortalTarget={document.body}
                    isClearable
                  />
                </Form.Group>
              </Col>
              <Col xs={12} sm={6} md={3} className="ml-md-auto">
                <Form.Group>
                  <Form.Label>Pesquisa</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Selecione"
                    value={pesquisa}
                    onChange={(e) => setPesquisa(e.target.value)}
                    style={{ height: 42 }}
                  />
                </Form.Group>
              </Col>
              {podeGerenciar && (
                <Col xs={12} sm={6} md={"auto"} className="mt-3">
                  <Button variant="primary" block className="d-md-inline-block" onClick={() => setShowModalInclusao(true)}>
                    <FaPlus className="mr-1" /> Novo Tópico
                  </Button>
                </Col>
              )}
            </Row>
            <Row className="align-items-center">
              <Col xs={12} sm={6} md={4}>
                <Form.Group>
                  <Form.Label>Data Criação</Form.Label>
                  <div className="d-flex flex-column flex-sm-row align-items-sm-center">
                    <Form.Control
                      type="date"
                      value={dataCriacaoInicio}
                      onChange={(e) => setDataCriacaoInicio(e.target.value)}
                      style={{ height: 42, minWidth: 0 }}
                    />
                    <span className="mx-2 text-muted d-none d-sm-inline">à</span>
                    <Form.Control
                      type="date"
                      value={dataCriacaoFim}
                      onChange={(e) => setDataCriacaoFim(e.target.value)}
                      style={{ height: 42, minWidth: 0 }}
                      className="mt-1 mt-sm-0"
                    />
                  </div>
                </Form.Group>
              </Col>
              <Col xs={12} sm={6} md={3}>
                <Form.Group>
                  <Form.Label>Usuário</Form.Label>
                  <Select
                    placeholder="Selecione"
                    options={usuarioOptions}
                    value={usuario}
                    onChange={setUsuario}
                    styles={customStyles}
                    components={{ DropdownIndicator }}
                    noOptionsMessage={() => 'Nenhuma opção'}
                    menuPortalTarget={document.body}
                    isClearable
                  />
                </Form.Group>
              </Col>
              <Col xs={12} sm={6} md={"auto"} className="mt-3 ml-md-auto">
                <div className="d-flex">
                  <Button variant="outline-secondary" onClick={handleLimpar} className="mr-2 flex-grow-1 flex-md-grow-0">
                    Limpar
                  </Button>
                  <Button variant="primary" onClick={handleBuscar} disabled={loading} className="flex-grow-1 flex-md-grow-0">
                    {loading ? (
                      <Spinner as="span" animation="border" size="sm" />
                    ) : (
                      <>
                        <FaSearch className="mr-1" /> Buscar
                      </>
                    )}
                  </Button>
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {itemSelecionado ? (
          <DetalhesFAQ
            item={itemSelecionado}
            onVoltar={() => setItemSelecionado(null)}
          />
        ) : (
          <>
            {/* TODO: substituir por renderização dos dados reais da API */}
            {registrosPaginados.length > 0 && registrosPaginados.map((item) => (
              <Card key={item.codigo} className="shadow-sm mb-2" style={{ cursor: 'pointer', overflow: 'hidden' }}>
                <Card.Body className="py-2 py-md-3 px-2 px-sm-3">
                  <div className="d-flex flex-column flex-md-row justify-content-between">
                    <div style={{ minWidth: 0, flex: 1, overflow: 'hidden', wordBreak: 'break-word' }}>
                      <span className="text-muted" style={{ fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                        {item.nome_departamento}
                      </span>
                      <p className="mb-1" style={{ fontSize: '0.9rem', fontWeight: 500, color: '#0747a6' }}>
                        {item.nome_assunto}
                      </p>
                      <h6 className="mb-1" style={{ fontSize: '1.05rem', fontWeight: 600 }}>
                        {item.titulo}
                      </h6>
                      <p className="text-muted mb-0" style={{ fontSize: '0.85rem', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                        {(item.texto || '').replace(/<br\s*\/?>/g, ' ')}
                      </p>
                    </div>
                    <div className="d-none d-md-flex flex-column justify-content-between align-items-end ml-3" style={{ flexShrink: 0 }}>
                      <span className="text-muted" style={{ fontSize: '0.75rem' }}>
                        {item.nome_usuario_criador} - {new Date(item.data_criacao).toLocaleDateString('pt-BR')}
                      </span>
                      {podeGerenciar && item.codigo_departamento === departamentoUsuario && (
                        <div className="mt-1">
                          <Button variant="outline-danger" size="sm" className="mr-2" title="Excluir" onClick={() => handleExcluir(item)}>
                            <FaTrash />
                          </Button>
                          <Button variant="outline-primary" size="sm" title="Editar" onClick={() => { setConteudoEdicao(item); setShowModalInclusao(true); }}>
                            <FaEdit />
                          </Button>
                        </div>
                      )}
                      <Button variant="link" className="text-muted p-0" onClick={() => setItemSelecionado(item)}>
                        <FaArrowRight />
                      </Button>
                    </div>
                  </div>
                  <div className="d-flex d-md-none flex-wrap justify-content-between align-items-center mt-2 pt-2 border-top" style={{ gap: '0.5rem' }}>
                    <span className="text-muted text-truncate" style={{ fontSize: '0.75rem', maxWidth: '60%' }}>
                      {item.nome_usuario_criador} - {new Date(item.data_criacao).toLocaleDateString('pt-BR')}
                    </span>
                    <div className="d-flex align-items-center" style={{ flexShrink: 0 }}>
                      {podeGerenciar && item.codigo_departamento === departamentoUsuario && (
                        <>
                          <Button variant="outline-danger" size="sm" className="mr-1" title="Excluir" onClick={() => handleExcluir(item)}>
                            <FaTrash />
                          </Button>
                          <Button variant="outline-primary" size="sm" className="mr-1" title="Editar" onClick={() => { setConteudoEdicao(item); setShowModalInclusao(true); }}>
                            <FaEdit />
                          </Button>
                        </>
                      )}
                      <Button variant="link" className="text-muted p-0" onClick={() => setItemSelecionado(item)}>
                        <FaArrowRight />
                      </Button>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            ))}

            {resultados.length === 0 && !loading && (
              <div className="text-center text-muted mt-5">
                <p>Nenhum resultado encontrado.</p>
              </div>
            )}

            {totalPages > 1 && (
              <div className="d-flex justify-content-center mt-3" style={{ overflowX: 'auto' }}>
                <Pagination className="flex-wrap justify-content-center">
                  <Pagination.First
                    onClick={() => trocarPagina(1)}
                    disabled={currentPage === 1}
                  />
                  <Pagination.Prev
                    onClick={() => trocarPagina(currentPage - 1)}
                    disabled={currentPage === 1}
                  />
                  {totalPages > 10 && currentPage > 5 && (
                    <Pagination.Item onClick={() => trocarPagina(1)}>
                      1
                    </Pagination.Item>
                  )}
                  {totalPages > 10 && currentPage > 5 && <Pagination.Ellipsis />}
                  {[...Array(totalPages).keys()]
                    .slice(
                      Math.max(0, currentPage - 6),
                      Math.min(totalPages, currentPage + 4)
                    )
                    .map((number) => (
                      <Pagination.Item
                        key={number}
                        active={currentPage === number + 1}
                        onClick={() => trocarPagina(number + 1)}
                      >
                        {number + 1}
                      </Pagination.Item>
                    ))}
                  {totalPages > 10 && currentPage < totalPages - 4 && (
                    <Pagination.Ellipsis />
                  )}
                  {totalPages > 10 && currentPage < totalPages - 4 && (
                    <Pagination.Item onClick={() => trocarPagina(totalPages)}>
                      {totalPages}
                    </Pagination.Item>
                  )}
                  <Pagination.Next
                    onClick={() => trocarPagina(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  />
                  <Pagination.Last
                    onClick={() => trocarPagina(totalPages)}
                    disabled={currentPage === totalPages}
                  />
                </Pagination>
              </div>
            )}
          </>
        )}
      </div>

      <ModalInclusao
        show={showModalInclusao}
        onHide={() => { setShowModalInclusao(false); setConteudoEdicao(null); }}
        conteudoEdicao={conteudoEdicao}
        onSave={handleBuscar}
        departamentoUsuario={departamentoUsuario}
      />

      <ModalConfirmacao
        show={showConfirmExcluir}
        onClose={confirmarExclusao}
        title="Excluir Tópico"
        message="Deseja realmente excluir este Tópico? Esta ação não poderá ser desfeita."
      />

    </>
  );
};

export default FAQ;
